import React from 'react';
import Modal from 'react-modal';

const PropertyImageModal = ({
  isOpen,
  onClose,
  images,
  currentIndex,
  onNext,
  onPrev,
  onIndicatorClick
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Property Images"
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
      className="property-image-modal"
      overlayClassName="property-image-modal-overlay"
      portalClassName='gallery-modal image-modal-full Media-Modal media-open-fullimg'
    >
      <div className="property-image-modal-container">
        {/* Close Button */}
        <button
          className="property-image-modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Carousel Container */}
        {images.length > 0 && (
          <div className="property-image-modal-carousel">
            <div className="property-image-modal-carousel-inner">
              {images.map((imageUrl, index) => (
                <div
                  key={index}
                  className={`property-image-modal-carousel-item ${currentIndex === index ? 'active' : ''}`}
                >
                  <img
                    src={imageUrl}
                    alt={`Property image ${index + 1} of ${images.length}`}
                    className="property-image-modal-image"
                  />
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            {images.length > 1 && (
              <>
                {currentIndex > 0 && (
                  <button
                    className="property-image-modal-nav property-image-modal-nav-prev"
                    onClick={onPrev}
                    aria-label="Previous image"
                  >
                    <span className="property-image-modal-nav-icon">‹</span>
                  </button>
                )}
                {currentIndex < images.length - 1 && (
                  <button
                    className="property-image-modal-nav property-image-modal-nav-next"
                    onClick={onNext}
                    aria-label="Next image"
                  >
                    <span className="property-image-modal-nav-icon">›</span>
                  </button>
                )}

                {/* Image Counter */}
                <div className="property-image-modal-counter">
                  {currentIndex + 1} / {images.length}
                </div>

                {/* Indicators */}
                <div className="property-image-modal-indicators">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`property-image-modal-indicator ${currentIndex === index ? 'active' : ''}`}
                      onClick={() => onIndicatorClick(index)}
                      aria-label={`Go to image ${index + 1}`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PropertyImageModal;
